import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../components/helpers";

export default function AllAppointments() {
  const [items, setItems] = useState([]),
    [search, setSearch] = useState(""),
    [loading, setLoading] = useState(true),
    [edit, setEdit] = useState(null);
  const navigate = useNavigate();
  const load = async () => {
    setLoading(true);
    try {
      const r = await apiFetch("get_all_appointments.php");
      if (r.status) setItems(r.data || []);
    } catch {}
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);
  const handleStatusChange = async (id, status) => {
    await apiFetch("update_appointment_status.php", {
      method: "POST",
      body: { appointment_id: id, status },
    });
    load();
  };
  const handleDelete = async (id) => {
    await apiFetch("delete_appointment.php", {
      method: "POST",
      body: { appointment_id: id },
    });
    load();
  };
  const handleUpdate = async () => {
    await apiFetch("update_appointment.php", { method: "POST", body: edit });
    setEdit(null);
    load();
  };
  const filtered = items.filter(
    (a) =>
      (a.patient_name || "").toLowerCase().includes(search.toLowerCase()) ||
      (a.doctor_name || "").toLowerCase().includes(search.toLowerCase()),
  );
  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>All Appointments</h2>
        <div className="d-flex gap-2">
          <input
            className="form-control"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            className="btn btn-primary"
            onClick={() => navigate("/assistant/create-appointment")}
          >
            + Add
          </button>
        </div>
      </div>
      <div className="card p-3">
        {loading ? (
          "Loading..."
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Patient</th>
                <th>Doctor</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((a) => (
                <tr key={a.appointment_id}>
                  <td>{a.patient_name}</td>
                  <td>{a.doctor_name}</td>
                  <td>{a.appointment_date}</td>
                  <td>{a.appointment_time}</td>
                  <td>{a.status}</td>
                  <td className="d-flex gap-1">
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() =>
                        setEdit({
                          ...a,
                          appointment_time: (a.appointment_time || "").slice(
                            0,
                            5,
                          ),
                        })
                      }
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(a.appointment_id)}
                    >
                      Delete
                    </button>
                    {a.status === "Pending" && (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() =>
                          handleStatusChange(a.appointment_id, "Completed")
                        }
                      >
                        Complete
                      </button>
                    )}
                    {a.status === "Completed" && (
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={() =>
                          handleStatusChange(a.appointment_id, "Pending")
                        }
                      >
                        Reopen
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {edit && (
        <div className="card p-3 mt-3">
          <h4>Edit Appointment</h4>
          <select
            className="form-select mb-2"
            value={edit.doctor_id || ""}
            onChange={(e) => setEdit({ ...edit, doctor_id: e.target.value })}
          >
            {items
              .map((x) => x.doctor_id)
              .filter((v, i, a) => a.indexOf(v) === i)
              .map((id) => (
                <option key={id} value={id}>
                  {filtered.find((f) => f.doctor_id === id)?.doctor_name ||
                    "Doctor " + id}
                </option>
              ))}
          </select>
          <input
            type="date"
            className="form-control mb-2"
            value={edit.appointment_date || ""}
            onChange={(e) =>
              setEdit({ ...edit, appointment_date: e.target.value })
            }
          />
          <input
            type="time"
            className="form-control mb-2"
            value={edit.appointment_time || ""}
            onChange={(e) =>
              setEdit({ ...edit, appointment_time: e.target.value })
            }
          />
          <select
            className="form-select mb-2"
            value={edit.status || "Pending"}
            onChange={(e) => setEdit({ ...edit, status: e.target.value })}
          >
            <option>Pending</option>
            <option>Completed</option>
            <option>Cancelled</option>
          </select>
          <div className="d-flex gap-2">
            <button className="btn btn-success" onClick={handleUpdate}>
              Save
            </button>
            <button className="btn btn-secondary" onClick={() => setEdit(null)}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
